import React, { useMemo } from 'react'
import arrayMutators from 'final-form-arrays'
import { Field, Form } from 'react-final-form'
import FormTextField from '../../../../../components/fields/FormTextField'
import { FieldArray } from 'react-final-form-arrays'
import FormFile from '../../../../../components/fields/FormFile'
import { FormattedMessage, IntlShape, useIntl } from 'react-intl'
import Loader from '../../../../../components/loader/Loader'
import Button from '../../../../../components/button/Button'
import { ClassValue } from 'classnames/types'
import classNames from 'classnames'
import { makeStyles } from '@material-ui/core/styles'
import styles from '../../../../../styles'
import { FormattedMessageModel } from '../../../../../types/fields/fieldsModel'
import { DateChoiceModel, MakeRequestModel, SpecificationsModel } from '../../../requestsModel'
import { modalTypes } from '../../../../../enums/modalTypeEnum'
import { requestPurpose, requestType } from '../../../../../enums/contractsEnum'
import 'moment/locale/fr'
import DateTimeSlotSelect from './DateTimeSlotSelect'
import { OnChange } from 'react-final-form-listeners'
import FormRadioField from '../../../../../components/fields/FormRadioField'
import { useMediaQuery } from 'react-responsive'
import { ASSURANCE_CONCERN } from '../Stepper'
import { formFieldsEnum } from '../step4-2/enums/formFieldsEnum'
import FormDatePickerField from '../../../../../components/fields/FormDatePickerField'
import { Grid } from '@material-ui/core'

const useStyle = makeStyles(
	(theme) => (
		{
			...styles(theme),
			formStyle: {
				marginBottom: 20
			},
			inputStyle: {
				'&:first-child': {
					marginBottom: 60
				},
				'&:nth-child(2)': {
					marginBottom: 20
				},
				'& textarea': {
					paddingTop: 8
				}
			},
			inputDateStyle: {
				'&:first-child': {
					marginInlineStart: 'auto',
					marginBottom: 60
				},
				'&:nth-child(2)': {
					marginBottom: 20
				},
				'& textarea': {
					paddingTop: 8
				}
			},
			buttonContainerStyle: {
				marginTop: 70
			},
			spinnerStyle: {
				textAlign: 'center'
			},
			chooseOptionStyle: {
				whiteSpace: 'pre-line',
				marginTop: 85,
				marginBottom: 30
			},
			timeSlotContainer: {
				paddingTop: '5%',
				paddingBottom: '5%'
			},
			dateText: {
				fontSize: 18,
				fontWeight: 500,
				color: theme.palette.blue.main,
				opacity: 0.7,
				lineHeight: 1.33
			},
			informationStyle: {
				whiteSpace: 'pre-line',
				marginBottom: 20
			},
			marginBottom: {
				marginTop: 30
			},
			assurance: {
				marginBottom: '32px !important',
				marginLeft: 0
			},
			labelAssurance: {
				marginRight: '50px',
			},
			sublabel: {
				color: theme.palette.blue['30'],
				marginRight: '-100px'
			},
			sublabelMargin: {
				marginBottom: '8px'
			}
		}
	)
)

const MESSAGE_NAME: string = 'message'
const MESSAGE_PLACEHOLDER: FormattedMessageModel = {
	id: 'requests.makeRequest.step4.messagePlaceholder',
	defaultMessage: 'Saisissez votre message',
	description: 'Input message placeholder'
}
const MESSAGE_OPTIONNEL_PLACEHOLDER: FormattedMessageModel = {
	id: 'requests.makeRequest.step4.messageOptionnelPlaceholder',
	defaultMessage: 'Saisissez votre message (Optionnel)',
	description: 'Input message placeholder'
}

const FILE_NAME: string = 'attachment'

const OPTIONS_NAME: string = 'choicesOption'

const DATE_CHOICE_NAME: string = 'dateChoices'

interface AcceptingProps {
	loading: boolean,
	onSubmit: (values: SpecificationsModel) => void,
	validate: (values: SpecificationsModel) => any,
	fromType: modalTypes,
	request?: Partial<MakeRequestModel>
}

type RequestFormProps = AcceptingProps

const RequestForm: React.FC<RequestFormProps> = (
	{
		loading,
		onSubmit,
		validate,
		fromType,
		request
	}
) => {
	const classes = useStyle()
	let submitButton: string
	let submitButtonDefaultMessage: string
	const isLargeScreen = useMediaQuery(
		{
			query: '(min-width: 1025px)'
		}
	)

	switch (fromType) {
		case modalTypes.demandes:
			submitButton = 'requests.makeRequest.step4.submit'
			submitButtonDefaultMessage = 'Envoyez votre demande'
			break
		case modalTypes.response:
			submitButton = 'requests.response.submit'
			submitButtonDefaultMessage = 'Envoyez votre réponse'
			break
		case modalTypes.service:
			submitButton = 'services.modal.form.submit'
			submitButtonDefaultMessage = 'Envoyer'
			break
	}

	const inputClass: ClassValue = classNames(
		'row',
		classes.inputStyle,
		request?.requestConcern === ASSURANCE_CONCERN ? classes.assurance : '',
	)

	const AssuranceClass: ClassValue = classNames(
		'row',
		classes.assurance
	)

	const informationClass = classNames(
		isLargeScreen ? classes.text11 : classes.text18,
		classes.colorBlue,
		classes.informationStyle
	)

	const buttonContainerClass: ClassValue = classNames(
		'row',
		classes.buttonContainerStyle
	)

	const chooseOptionClass: ClassValue = classNames(
		isLargeScreen ? [classes.text11] : [classes.text18],
		classes.colorBlue,
		classes.chooseOptionStyle
	)

	const timeSlotContainer: ClassValue = classNames(
		classes.timeSlotContainer,
		'row',
		'col-xs-12'
	)

	const intl: IntlShape = useIntl()

	const choice1: string = intl.formatMessage({
		id: 'requests.makeRequest.step4.keyExampleOption',
		defaultMessage: 'Je laisse un exemplaire de mes clés au bureau d\'accueil de mon YouFirst Manager',
		description: 'choice key'
	})
	const choice2: string = intl.formatMessage({
		id: 'requests.makeRequest.step4.datesOption',
		defaultMessage: 'Je sélectionne trois créneaux',
		description: 'choice date'
	})
	const choice3: string = intl.formatMessage({
		id: 'requests.makeRequest.step4.advisorOption',
		defaultMessage: 'Je préfère être contacté par mon YouFirst Manager',
		description: 'choice advisor'
	})
	const defaultDate: string = intl.formatMessage({
		id: 'requests.makeRequest.step4.dateText',
		defaultMessage: 'Date',
		description: 'text date in select'
	})
	const defaultTimeSlot: string = intl.formatMessage({
		id: 'requests.makeRequest.step4.timeSlotText',
		defaultMessage: 'Créneau',
		description: 'text timeSlot in select'
	})

	const arrayChoices: Array<string> = [choice1, choice2, choice3]

	const [value, setValue] = React.useState('')
	const initialValues = useMemo(() => ({
		dateChoices: [{ weekDay: defaultDate, timeSlot: defaultTimeSlot }, { weekDay: defaultDate, timeSlot: defaultTimeSlot }, {
			weekDay: defaultDate,
			timeSlot: defaultTimeSlot
		}]
	}), [defaultDate, defaultTimeSlot])

	const assuranceInformation: ClassValue = classNames(
		isLargeScreen ? classes.text11 : classes.text18,
		classes.colorBlue,
		classes.informationStyle,
		classes.sublabelMargin
	)

	const subLabel: ClassValue = classNames(
		classes.text8,
		classes.sublabel,
		classes.sublabelMargin
	)

	const requiredArray = (values: DateChoiceModel[]) => {
		const errors: any = {}
		if (values) {
			values.forEach((dateChoice, index) => {
				if (index < 2) {
					if (dateChoice.timeSlot === defaultTimeSlot || dateChoice.weekDay === defaultDate) {
						errors[index] = { timeSlot: '', weekDay: '' }
						if (dateChoice.timeSlot === defaultTimeSlot) {
							errors[index].timeSlot = intl.formatMessage(
								{
									id: 'global.errors.required',
									defaultMessage: 'Requis*',
									description: 'Required message'
								}
							)
						}
						if (dateChoice.weekDay === defaultDate) {
							errors[index].weekDay = intl.formatMessage(
								{
									id: 'global.errors.required',
									defaultMessage: 'Requis*',
									description: 'Required message'
								}
							)
						}
					} else {
						if (values.some((value, i) => i !== index && value.weekDay === dateChoice.weekDay && value.timeSlot === dateChoice.timeSlot)) {
							errors[index] = { timeSlot: '', weekDay: '' }
							errors[index].timeSlot = intl.formatMessage(
								{
									id: 'global.errors.sameDateChoice',
									defaultMessage: 'Date et créneau déjà choisis',
									description: 'Already exist a same date message'
								}
							)
						}
					}
				}

			})
		}
		return errors
	}

	const dateEffetBail = Array.isArray(request?.contract) ? request?.contract[0].dateEffet?.toISOString().split('T')[0] : request?.contract?.dateEffet?.toISOString().split('T')[0]

	return (
		<Form
			mutators={{
				...arrayMutators
			}}
			initialValues={initialValues}
			onSubmit={onSubmit}
			validate={validate}
			render={
				(
					{
						handleSubmit
					}
				) => (
					<form
						onSubmit={handleSubmit}
						className={classes.formStyle}
					>
						{
							request && request.requestConcern === ASSURANCE_CONCERN ? (
									<>
										<div className={inputClass}>
											<Field
												name={MESSAGE_NAME}
												component={FormTextField}
												placeholder={MESSAGE_OPTIONNEL_PLACEHOLDER}
												multiline
												maxLength={1500}
											/>
										</div>
										<div className={AssuranceClass}>
											<Grid container item xs={12} md={12}>
													<span className={assuranceInformation}>
														<FormattedMessage
															id="requests.makeRequest.step4.assurance.dateDebut.label"
															defaultMessage="Date de début d'assurance"
															description="Assurance end date field"
														/> *
													</span>
												<Grid item xs={12}>
													<span className={subLabel}>
														<FormattedMessage
															id="requests.makeRequest.step4.assurance.dateDebut.sublabel"
															defaultMessage="Renseignez ici la date de début de votre nouvelle attestation d'assurance"
														/>
													</span>
												</Grid>
												<Grid item xs={12} md={6}>
													<Field
														name={formFieldsEnum.dateDebutAssurance}
														type="date"
														component={FormDatePickerField}
														inputTextStyle={classes.dateText}
														disableToolbar={false}
														isGreyBackground={false}
														selectFuture={false}
														setMaxDate={dateEffetBail}
														dateToDisable={undefined}
													/>
												</Grid>
											</Grid>
										</div>
										<div className={AssuranceClass}>
											<Grid container item xs={12} md={12}>
													<span className={assuranceInformation}>
														<FormattedMessage
															id="requests.makeRequest.step4.assuranceFin.date.label"
															defaultMessage="Date de fin d'assurance"
															description="Assurance end date field"
														/> *
													</span>
												<Grid item xs={12}>
													<span className={subLabel}>
														<FormattedMessage
															id="requests.makeRequest.step4.assuranceFin.date.sublabel"
															defaultMessage="Renseignez ici la date de fin de votre nouvelle attestation d'assurance"
														/>
													</span>
												</Grid>
												<Grid item xs={12} md={6}>
													<Field
														name={formFieldsEnum.dateFinAssurance}
														type="date"
														component={FormDatePickerField}
														inputTextStyle={classes.dateText}
														disableToolbar={false}
														isGreyBackground={false}
														selectFuture={true}
														setMinDate={dateEffetBail}
														setMaxDate={undefined}
														dateToDisable={undefined}
													/>
												</Grid>
											</Grid>
										</div>
										<Grid container item xs={12}>
										<span className={informationClass}>
											<FormattedMessage
												id="requests.makeRequest.step4.assurance.information"
												defaultMessage="Veuillez nous transmettre votre attestation d’assurance."
												description="Assurance deposit information label"
											/>
										</span>
										</Grid>
									</>
								)
								:
								<div className={inputClass}>
									<div className="col-xs-12">
										<Field
											name={MESSAGE_NAME}
											component={FormTextField}
											placeholder={MESSAGE_PLACEHOLDER}
											multiline
											maxLength={1500}
										/>
									</div>
								</div>
						}

						{
							fromType !== modalTypes.service && (
								<div>
									<div className="col-xs-12">
										<FieldArray
											name={FILE_NAME}
											render={
												(
													{
														fields,
														meta
													}
												) => (
													<FormFile
														fields={fields}
														meta={meta}
														label={
															<FormattedMessage
																id="requests.makeRequest.step4.attachmentLabel"
																defaultMessage="Ajouter une pièce jointe"
																description="Input placeholder"
															/>
														}
														id={FILE_NAME}
													/>
												)
											}
										/>
									</div>
								</div>
							)
						}

						{
							request && request.requestType === requestType.technical && request.requestPurpose === requestPurpose.private &&
							<div className="row col-xs-12">
								<span className={chooseOptionClass}>
                                    <FormattedMessage
	                                    id="requests.makeRequest.step4.chooseOption"
	                                    defaultMessage="Afin de nous permettre de programmer une intervention, si nécessaire, nous vous invitons à sélectionner l'une des trois options suivantes :"
	                                    description="Choose option text"
                                    />
							    </span>
								<Field
									name={OPTIONS_NAME}
									component={FormRadioField}
									items={arrayChoices.map((choice: string) => ({
										value: choice,
										label: choice
									}))}
									textStyle={isLargeScreen ? 'text1_opacity' : 'text2_opacity'}
									textColor="colorBlue"
									textWeight="medium"
									margin={false}
									type="radio"
									rowDirection={false}
								/>
								<OnChange name={OPTIONS_NAME}>
									{(value: React.SetStateAction<string>, previous: any) => {
										setValue(value)
									}}
								</OnChange>
							</div>
						}
						{
							value === choice2 &&
							<div className={timeSlotContainer}>
								<FieldArray
									name={DATE_CHOICE_NAME}
									validate={requiredArray}
									render={
										(
											{
												fields,
												meta

											}
										) => {
											return (
												fields.map((name, index) => {
													return (
														<div key={name} className="row col-xs-12">
															<DateTimeSlotSelect
																name={name}
																errors={meta.error[index]}
																labelChoice={
																	intl.formatMessage({
																		id: `requests.makeRequest.step4.choice${index + 1}`,
																		defaultMessage: `Choix ${index + 1}`,
																		description: `choice${index + 1} option text`
																	})
																}
																isLargeScreen={isLargeScreen}
															/>
														</div>
													)
												})
											)
										}}
								/>
							</div>
						}

						<div className={buttonContainerClass}>
							<div className="col-xs-12 col-md-4">
								{
									loading ? (
										<div className={classes.spinnerStyle}>
											<Loader />
										</div>
									) : (
										!(request && request.requestType === requestType.technical && request.requestPurpose === requestPurpose.private && !value) &&
										<Button
											background="backgroundAccessibility"
											color="colorWhite"
											textStyle="text8"
											type="submit"
											size="bigButton"
										>
											<FormattedMessage
												id={submitButton}
												defaultMessage={submitButtonDefaultMessage}
												description="Submit message"
											/>
										</Button>
									)
								}
							</div>
						</div>
					</form>
				)
			}
		/>
	)
}

export default RequestForm